import { Tab as Element } from "./Tab";
import { Tabs as Container } from "./Tabs";

export type { Props, TabProps } from "./Tabs.types";

export const Tabs = {
  Container,
  Element,
};
